export const TABS = {
  COMMENTS: 'comments',
  TASKS: 'tasks',
  CALENDAR: 'calendar',
  APPROVALS: 'approvals',
  REVIEW: 'review',
  COPILOT: 'copilot',
  ACTIVITY_FEED: 'activityFeed'
};
export const VALUES_OF_TABS = Object.values(TABS);
export const TAB_SET = new Set(VALUES_OF_TABS);